import { Customer, InputRuleApiModel, RequiredIfModel } from '~/lib/api/smartsend/types';
import sanitiseValue from '~/lib/utils/value-sanitiser';

const conditionalIsRequired = (m: InputRuleApiModel, customer: Customer) => {
  if (!m?.dataRequiredIf) {
    return undefined;
  }

  let output = undefined;

  const conditional =
    typeof m.dataRequiredIf === 'string' ? (JSON.parse(m.dataRequiredIf) as RequiredIfModel) : m.dataRequiredIf;

  conditional?.All?.forEach((c) => {
    const fieldToCheckValue: string = customer.Meta[c.Field] ? customer.Meta[c.Field]?.Value : customer[c.Field];
    if (sanitiseValue(fieldToCheckValue) === sanitiseValue(c.Value)) {
      output = true;
    }
  });

  return output;
};

export default conditionalIsRequired;
